import {
    AnimationBaseController,
    GameApiBase, GameRandom,
    GameStorageManager
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";
import { Point } from "pixi.js";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { DbCoinController } from "../../Common/DbCoinController";


export interface IUIControllerLeftOptions {
}

export class UIControllerLeftContainer extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IUIControllerLeftOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private _arenaApi: GameApiBase) {
        super("UIControllerLeftContainer");
        console.log('UIControllerLeftContainer', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{

            childControllers: {
                /*DBCoin: {
                    controller: DbCoinController,
                    model: this.$model,
                    x: -0,
                    y: 7
                }*/
            },
            modelWatch: {
                "player.lives": (lives: number) => {
                    this._setState();
                },
                'userProfile.coinsCount': (coins: number) => {
                    this._setState();
                    this.setTextByQuery("coin.coin_text", `${this.$model.userProfile.coinsCount}`);
                },
                'distance': () => {
                    this.setTextByQuery("coin.coin_text", `${Number(this.$model.userProfile.coinsCount) + this._gameLogic.getWinCoins()}`);
                },
            }
        };
    }

    protected onInitialize(): void {
        this._setState();
        this.setTextByQuery("coin.coin_text", `${this.$model.userProfile.coinsCount}`);
        //this.$childControllers.get < DbCoinController>('DBCoin').blick();
    }

    protected onLandscape(): void {

    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
    protected onResize(width: number, height: number, scale: number): void {
        const padding = new Point(300, 50);
        this.x = padding.x;
        this.y = (-height / scale - this.$model.cameraPos.y) / this.$model.cameraZoom + padding.y;

    }
    private _setState() {
        this.setTextByQuery("xp.live_counter", `${this.$model.player.lives}`);
    }
}

